import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import logo from './logo.svg';

import styles from './CnilModale.module.scss';
import CheckBox from '../../lib/HooksFormFields/CheckBox/CheckBox';
import { putProfileAction } from '../../actions/authActions';

export default function CnilModale() {
  const dispatch = useDispatch();
  const {
    watch,
    control,
  } = useForm({
    defaultValues: {
      mailAccepted: false,
    },
  });
  async function onSubmit() {
    const data = { ...watch(), consentDate: new Date().toISOString() };
    putProfileAction(dispatch, data);
  }
  return (
    <div className={styles.container}>
      <div className={styles.logo}>
        <img src={logo} alt="logo" />
      </div>
      <h4>Votre vie privée est importante pour nous</h4>
      <p>
        Les informations recueillies vous concernant font l’objet d’un traitement destiné
        à vous proposer des services développés par Octapharma
        {' '}
        et dédiés aux professionnels de santé.
        <br />
        Conformément à la réglementation sur la protection des données personnelles,
        vous avez un droit d’accès, de rectification,
        d’opposition, d’effacement et de limitation du traitement des données vous concernant,
        pour exercer ces droits, vous devez adresser votre demande à
        {' '}
        <a href="mailto:FR2DPO@octapharma.com">FR2DPO@octapharma.com</a>
        .
      </p>
      <CheckBox
        label="Si vous ne souhaitez pas recevoir de mails relatifs à la présentation de nouveaux services, nous vous remercions de bien vouloir cocher cette case."
        defaultValue={false}
        control={control}
        name="mailAccepted"
      />
      <div className={styles.submit}>
        <button
          type="button"
          className={`${styles.btn}`}
          onClick={() => onSubmit()}
        >
          Valider
        </button>
      </div>
    </div>
  );
}
